import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentConfirmation = ({
  paymentStatus,
  paymentProvider,
  backTo = "/",
  backLabel = "ZURÜCK ZUM KALENDER",
  generalErrorMessage = "Das gewünschte Produkt wurde nicht gekauft."
}) => {
  const navigate = useNavigate();

  const renderContent = () => {
    switch (paymentStatus) {
      case "success":
        return (
          <div className="text-center">
            <h1 className="text-pegasusPurpleHover font-bold text-2xl mb-4">Glückwunsch, das hat geklappt!</h1>
            <p className="text-gray-600 mb-6">Die Zahlung war erfolgreich.</p>
            <button
              onClick={() => navigate(backTo)}
              className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
            >
              {backLabel}
            </button>
          </div>
        );
      case "pending":
        return (
          <div className="text-center">
            <h1 className="text-pegasusPurpleHover font-bold text-2xl mb-4">Zahlung wird verarbeitet</h1>
            <p className="text-gray-600 mb-6">
              Deine Zahlung wurde angestoßen und wird von deiner Bank verarbeitet. Sobald wir die
              Bestätigung erhalten, senden wir dir eine E-Mail.
            </p>
            <button
              onClick={() => navigate(backTo)}
              className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
            >
              {backLabel}
            </button>
          </div>
        );
      case "event_full":
        return (
          <div className="text-center">
            <div className="bg-red-100 text-red-600 border-l-4 border-red-600 p-4 mb-4">
              Dieser Termin wurde abgesagt und kann leider nicht gebucht werden.
            </div>
            <h1 className="text-gray-800 font-bold text-xl mb-4">Payment failed</h1>
            <button
              onClick={() => navigate(backTo)}
              className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
            >
              {backLabel}
            </button>
          </div>
        );
      case "expired":
        return (
          <div className="text-center">
            <div className="bg-red-100 text-red-600 border-l-4 border-red-600 p-4 mb-4">
              Das Zahlungsfenster ist leider abgelaufen.
            </div>
            <h1 className="text-gray-800 font-bold text-xl mb-4">Payment failed</h1>
            <p className="text-gray-600 mb-6">Bitte versuche es erneut.</p>
            <button
              onClick={() => navigate(backTo)}
              className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
            >
              {backLabel}
            </button>
          </div>
        );
      case "aborted":
        return (
          <div className="text-center">
            <h1 className="text-pegasusPurpleHover font-bold text-xl mb-4">Zahlung abgebrochen</h1>
            <p className="text-gray-600 mb-6">
              Die Zahlung wurde nicht abgeschlossen, es wurde nichts gebucht. Bitte versuche es erneut!
            </p>
            <button
              onClick={() => navigate(backTo)}
              className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
            >
              {backLabel}
            </button>
          </div>
        );
      case "general_error":
        return (
          <div className="text-center">
            <h1 className="text-pegasusPurpleHover font-bold text-xl mb-4">{paymentProvider}-Zahlung fehlgeschlagen!</h1>
            <p className="text-gray-600 mb-6">
              Die {paymentProvider}-Zahlung wurde abgebrochen. {generalErrorMessage}
              Bitte versuche es erneut!
            </p>
            <button
              onClick={() => navigate(backTo)}
              className="bg-pegasusPurple text-white py-2 px-6 rounded-lg hover:bg-pegasusPurpleHover"
            >
              {backLabel}
            </button>
          </div>
        );
      default:
        return <p>Zahlung wird verarbeitet...</p>;
    }
  };

  return (
    <div className="container mx-auto max-w-4xl p-6 bg-white rounded-lg shadow-md">
      {renderContent()}
    </div>
  );
};

export default PaymentConfirmation;
